export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs font-medium mb-6">
              <i className="ri-shield-check-line text-sm"></i>
              Trust &amp; Safety
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              Is OOPBuy Spreadsheet Safe to Use?
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6">
              <strong>OOPBuy Spreadsheet</strong> itself is an informational and organizational system. Safety depends on how users interact with external platforms and vendors. The spreadsheet system is designed to increase transparency, not process payments directly.
            </p>

            <ul className="space-y-4 mb-8">
              {safetyPoints.map((point, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-700 leading-relaxed">{point}</span>
                </li>
              ))}
            </ul>

            <div className="bg-secondary-100 rounded-xl p-5 border border-secondary-200/60">
              <p className="text-xs text-foreground-500 leading-relaxed">
                <i className="ri-information-line text-sm mr-1 align-text-bottom"></i>
                This website provides educational information only and does not process transactions. Always verify external sellers and use trusted payment methods when making purchases.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20home%20office%20desk%20with%20an%20iMac%20displaying%20a%20security%20dashboard%20with%20verified%20checkmarks%2C%20a%20leather%20bound%20journal%20and%20pen%20nearby%2C%20soft%20warm%20lamp%20light%20creating%20a%20secure%20comfortable%20atmosphere%2C%20professional%20trust%20building%20photography%2C%20charcoal%20and%20warm%20brass%20tones%2C%20sense%20of%20safety%20and%20reliability&width=800&height=1000&seq=safety-section-v2&orientation=portrait"
                alt="OOPBuy Spreadsheet safety and trust"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-5 py-3 border border-background-200/60">
              <p className="text-xs text-foreground-500">Trust Signal</p>
              <p className="text-sm font-semibold text-foreground-950">Educational Guide Only</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const safetyPoints = [
  'Always verify external sellers and their reputations before making any purchase',
  'Use trusted and secure payment methods with buyer protection features',
  'Double-check product information, specifications, and pricing before confirming orders',
  'Keep records of all transactions and communications for reference',
  'Avoid clicking on unverified links or sharing sensitive personal information unnecessarily',
];